import snackbarReducer from './snackbarReducer';

export default snackbarReducer;
